module.exports = {
      id: "freeform-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#freeform-icon",
      toString: function () {
        return this.url;
      }
    }